import React, { useRef, useState } from 'react';

import { Button, Typography, Box, Link } from '@mui/material';

import GoogleButtonLib from 'react-google-button';
import Markdown from '../utils/Markdown';
import EntityParams from './EntityParams';
import LoadingDial from '../loading/LoadingDial';
import { getLocalization } from '../../redux/selectors';

// Extract the default export if it exists
const GoogleButton = GoogleButtonLib?.default || GoogleButtonLib;

const EntityConnect = ({
  entity,
  helperText,
  flowId,
  linkedSource,
  linkedTarget,
  linkedConnector,
  listener,
  widgetTenant,
  multipleTenantLinks,
  isConnected,
  connectParams,
  nextStep,
}) => {
  const [isLoading, setLoading] = useState(false);
  const localization = getLocalization();
  const formEl = useRef();
  if (!entity) return <LoadingDial />;
  return (
    <Box display="flex" flexDirection="column" width="100%" flex={1} justifyContent="space-between">
      {isLoading && (
        <Box display="flex" flexDirection="column" height={439} justifyContent="center" alignItems="center" gap={4}>
          <LoadingDial />
        </Box>
      )}

      <Box display={isLoading ? 'none' : 'flex'} flexDirection="column">
        <Box display="flex" px={2} gap={1} flexDirection="column" alignItems={'center'} justifyContent={'center'}>
          <Box display="flex" gap={2} flexDirection="column" alignItems={'center'} justifyContent={'center'}>
            <Box component="img" src={entity.icon} width="72px" height="72px" sx={{ objectFit: 'contain' }} />
            <Box display="flex" flexDirection="column" gap={1} justifyContent={'center'} alignItems="center">
              <Typography variant="h2">{entity.label}</Typography>
              <Typography variant="body2" color="text.lightish">
                {localization?.connectSourceScreen?.instructionText || `Connect ${entity.label} below`}
              </Typography>
            </Box>
          </Box>
          {helperText && <Markdown>{helperText}</Markdown>}
        </Box>
        <EntityParams
          entity={entity}
          flowId={flowId}
          connectParams={connectParams}
          isConnected={isConnected}
          listener={listener}
          widgetTenant={widgetTenant}
          multipleTenantLinks={multipleTenantLinks}
          linkedSource={linkedSource}
          linkedTarget={linkedTarget}
          linkedConnector={linkedConnector}
          setLoading={setLoading}
          formStyles={{ pt: 3 }}
          formEl={formEl}
          height={'auto'}
          nextStep={nextStep}
        />
      </Box>
      <Box
        p={2}
        position="sticky"
        bottom={0}
        bgcolor="background.paper"
        zIndex="10"
        sx={{
          margin: !isConnected && entity?.customLoginButton === 'google' ? '0 auto' : 'initial',
        }}
      >
        {!isConnected && entity?.customLoginButton === 'google' ? (
          <GoogleButton
            onClick={() => {
              formEl?.current && formEl?.current?.handleSubmit();
            }}
            disabled={isLoading}
          />
        ) : (
          <Button
            type="submit"
            form="app-params-form"
            variant="contained"
            color="accent"
            fullWidth
            disabled={isLoading}
            sx={{
              height: '56px',
              fontSize: '16px'
            }}
          >
            {!isConnected
              ? localization?.connectSourceScreen?.connectDataButtonText || 'Connect your data'
              : localization?.connectSourceScreen?.saveConfigurationButtonText || 'Save your configurations'}
          </Button>
        )}
      </Box>
    </Box>
  );
};
export default EntityConnect;
